import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { ChecklistItem } from '@frontend/Models/Checklist';
import { useDCData } from '../../../DCTable/hooks/useDCData';
import { DCItem } from '../../../DCTable/components/DCItem';
import { DCModal } from '../../../DCTable/components/DCModal';
import AddDC from '../../../DCTable/AddDC/AddDC';
import '../../../DCTable/DCTable.css';

const ChecklistList: React.FC = () => {
  const { matterId } = useParams<{ matterId: string }>();
  const [showAddDC, setShowAddDC] = useState<boolean>(false);

  const {
    checklistItems,
    loading,
    error,
    addChecklistItem,
  } = useDCData(matterId);

  const handleItemCreated = (item: ChecklistItem): void => {
    addChecklistItem(item);
    setShowAddDC(false);
  };

  return (
    <div className="matter-checklist-container">
      <div className="matter-checklist-header">
        <div className="matter-checklist-tabs-container">
          <div className="matter-checklist-tabs-wrapper">
            <h2 style={{ color: 'var(--text-on-primary)', margin: 0 }}>
              Checklist ({checklistItems.length})
            </h2>
          </div>
        </div>
        <button className="matter-checklist-add-button" onClick={() => setShowAddDC(true)}>
          +
        </button>
      </div>

      {error ? (
        <div className="matter-checklist-error">Error: {error}</div>
      ) : (
        <div className="matter-checklist-content-container">
          {loading ? (
            <div className="matter-checklist-loading-message">
              Loading checklist items...
            </div>
          ) : checklistItems.length === 0 ? (
            <div className="matter-checklist-loading-message">
              No checklist items yet. Click + to add one.
            </div>
          ) : (
            checklistItems.map((item, index) => (
              <DCItem key={index} item={item} />
            ))
          )}
        </div>
      )}

      <DCModal isOpen={showAddDC} onClose={() => setShowAddDC(false)}>
        <AddDC
          onClose={() => setShowAddDC(false)}
          onItemCreated={(item) => handleItemCreated(item)}
        />
      </DCModal>
    </div>
  );
};

export default ChecklistList;
